const API_URL = "https://api.survey.yflow.io/v1/";

export { API_URL };
